import { IAppState } from '../../redux';
import { getLocationPathFromAddress } from '../../utils/offer';
import { selectUserGeoId } from '../user';

export const selectLocationsFromAddress = (state: IAppState): Array<number> => {
  const userLocations = [selectUserGeoId(state)];

  const locations = getLocationPathFromAddress(state.offer);

  return locations.length > 0 ? locations : userLocations;
};
